import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { getMonthRangeDatesMTD } from 'utils/date-functions';

import PackageRevenuePageHeader from './components/PackageRevenuePageHeader';
import PackageRevenueTable from './components/PackageRevenueTable';
import { SearchFilters } from './types';

const PackageRevenue = (): JSX.Element => {
  const defaultDates = getMonthRangeDatesMTD();

  const initialSearchFiltersValue: SearchFilters = {
    dateRange: [defaultDates[0], defaultDates[1]],
  };
  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('-revenue');

  return (
    <>
      <PackageRevenuePageHeader
        initialSearchFiltersValue={initialSearchFiltersValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        orderingValue={orderingValue}
      />

      <PackageRevenueTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default PackageRevenue;
